export default __webpack_public_path__ + "static/button-anatomy-light-f745d7c73891be5a652f8d42f5b49df42511ea711aec0727ceaf59e207f85564.png";